import React, { useEffect } from "react";
import { useParams } from 'react-router-dom';
import categories from '../../assets/Data/categories';
import ProductCard from '../ProductCard/ProductCard';
import { motion } from 'framer-motion';
import "./ProductList.css";
import { NavLink } from "react-router-dom";

function ProductList() {
  const { catId } = useParams();
  const catList = categories.filter((cat) => cat.catId === catId);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [catId]);



  return (
    <div>
      
      {catList.length > 0 ? (
        catList.map((category) => (
            <motion.div
            key={category.catId}
            className="hoPrdts prodlsit"
            initial={{ opacity: 1 }}
            whileInView={{ opacity: 10 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: false }}
          >
            <div className="pdLtmaxW">
            <div className="bcrumb">
            <div className="breadcrumb">
            <NavLink to="/">Home</NavLink> / <span>{category.title}</span>
          </div>
          </div>
              
              <div className="prIMgCOn">
                <motion.div
                  className="proLiwrp"
                  initial="visible"
                  whileInView="visible"
                  variants={{
                    hidden: { opacity: 20, y: 30 },
                    visible: {
                      opacity: 1,
                      y: 0,
                      transition: { staggerChildren: 0.2, duration: .9, ease: "easeOut" },
                    },
                  }}
                  viewport={{ once: false }}
                >
                  {category.products.map((product, index) => (
                     <ProductCard key={index} {...product} title={category.title} catId={category.catId} link={category.link} />
                  ))}
                </motion.div>
              </div>
            </div>
          </motion.div>
        ))
      ) : (
        <p>Category not found.</p>
      )}
    </div>
  );
}

export default ProductList;
